const copyToCilpboard = (text) => {
        const el = document.createElement("textarea");
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        Swal.fire({
          html: "<b>Copied To Clipboard Successfully!</b>",
          timer: 1000,
          icon: "success",
          showConfirmButton: false,
        });
      };